import { useLocation } from 'react-router-dom'

import type { Photos } from '@jotta/types/Photos'

import { AlbumListFrame } from '../AlbumList/AlbumList'
import { AlbumSectionContainer } from '../AlbumsSection/AlbumSectionContainer'

interface AlbumCollectionRouteProps {
  albumType: Photos.DisplayCollectionTypeKey
}

export function AlbumCollectionRoute({ albumType }: AlbumCollectionRouteProps) {
  const { pathname } = useLocation()

  return (
    <AlbumListFrame>
      <AlbumSectionContainer
        albumType={albumType}
        showAll
        backPath={pathname}
      />
    </AlbumListFrame>
  )
}
